import { DISMISS_AI_FORECASTING_V2_ALERT, DISMISS_EXCHANGE_RATE_ALERT, DISMISS_GOALS_BUG_ALERT, DISMISS_NEW_YEAR_ALERT } from '../actions/ActionTypes';
const initialState = {
  dismissedNewYearAlert: false,
  dismissedExchangeRateAlert: false,
  dismissedAIForecastingV2Alert: false,
  dismissedGoalsBugAlert: false
};
export default function alerts(state = initialState, action) {
  switch (action.type) {
    case DISMISS_NEW_YEAR_ALERT:
      return Object.assign({}, state, {
        dismissedNewYearAlert: true
      });
    case DISMISS_EXCHANGE_RATE_ALERT:
      return Object.assign({}, state, {
        dismissedExchangeRateAlert: true
      });
    case DISMISS_AI_FORECASTING_V2_ALERT:
      return Object.assign({}, state, {
        dismissedAIForecastingV2Alert: true
      });
    case DISMISS_GOALS_BUG_ALERT:
      return Object.assign({}, state, {
        dismissedGoalsBugAlert: true
      });
    default:
      return state;
  }
}